import { render, staticRenderFns } from "./service_account_project_memberships.vue.js?vue&type=template&id=3c11f3ae&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./service_account_project_memberships.vue?vue&type=template&id=3c11f3ae&vue3"
import script from "./service_account_project_memberships.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./service_account_project_memberships.vue?vue&type=script&lang=js&vue3"
export * from "./service_account_project_memberships.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./service_account_project_memberships.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports